import { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { type AnimationPhase, useAnimatedBannerWidth } from "utils/hooks/use-animated-banner-width";

interface AnimatedBannerWrapperProps {
  children: ReactNode;
  isVisible: boolean;
  enabled?: boolean;
  className?: string;
}

const isAnimatingPhase = (phase: AnimationPhase) =>
  phase === "animating" || phase === "exitAnimating";

export const AnimatedBannerWrapper: FC<AnimatedBannerWrapperProps> = ({
  children,
  isVisible,
  enabled = true,
  className,
}) => {
  const { animationPhase, bannerContentRef, bannerWidth } = useAnimatedBannerWidth({
    isVisible,
    enabled,
  });

  if (!enabled) {
    return null;
  }

  return (
    <div className={className}>
      <div
        className={twMerge(
          "overflow-hidden",
          isAnimatingPhase(animationPhase) && "transition-[width] duration-700 ease-out",
        )}
        style={{
          width:
            animationPhase === "offset" || animationPhase === "exitAnimating"
              ? 0
              : animationPhase === "animating" || animationPhase === "exitOffset"
                ? (bannerWidth ?? undefined)
                : undefined,
        }}
      >
        <div
          className={twMerge("flex items-center gap-2", animationPhase !== "idle" && "invisible")}
          ref={bannerContentRef}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
